// 모바일/웹 화면 구분.
//
// 퍼블리싱이 데스크톱(1920)과 모바일(375) 두 벌이라 화면 자체를 갈아 끼운다.
// CSS 로 감추는 방식은 쓰지 않는다 — 본문 생성물이 1,500줄 안팎이라
// 두 벌을 모두 DOM 에 두면 데이터 바인딩도 두 번 돌고 이미지도 두 배로 받는다.
//
// 기준은 Tailwind 기본 md(768px)다. 세 저장소가 같은 값을 쓴다.
import { onBeforeUnmount, onMounted, ref } from 'vue'

export const MOBILE_QUERY = '(max-width: 767px)'

export function useIsMobile() {
  // 서버 렌더나 matchMedia 가 없는 환경에서는 데스크톱으로 본다.
  const isMobile = ref(
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(MOBILE_QUERY).matches
      : false,
  )

  let mq = null
  const sync = () => {
    isMobile.value = mq.matches
  }

  onMounted(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    mq = window.matchMedia(MOBILE_QUERY)
    mq.addEventListener('change', sync)
    sync()
  })

  onBeforeUnmount(() => {
    mq?.removeEventListener('change', sync)
    mq = null
  })

  return isMobile
}
